import {
  RouteComponentProps,
  withRouter,
  useHistory,
  NavLink,
  useLocation
} from "react-router-dom"

import { CommonText, userSettingsKey } from "../../common/text"

import {
  logonUser,
  logoutUser,
  IMenuItem
} from "../../containers/applicationSlice"

import { HandlingApp, PageId } from "../../common/pageId"
import { login3, logout, requestUserPermissions } from "../../api/BackendCalls"
import DropdownButton from "../generic/buttons/DropdownButton"
import { updateUserSettingsSelection } from "../../containers/selectionSlice"
import CustomModal from "../modal"
import { useEffect, useState } from "react"
import RadioBooleanField from "../generic/form/RadioBooleanField"
import Button from "../generic/buttons/Button"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { LoadingPanel } from "../generic"

interface IProps extends RouteComponentProps<any> {
  menu: IMenuItem[]
}
interface IItem {
  items: unknown
  name: string
  pageId: string
}
const LoginDialog: React.FunctionComponent<IProps & RouteComponentProps> = ({
  menu
}) => {
  const pageId = PageId.Login

  const history = useHistory()
  const { pathname } = useLocation()
  const dispatch = useAppDispatch()

  const { userInfo, versionInfo } = useAppSelector(
    (state) => state["appReducer"]
  )
  const { useSSIMView } = useAppSelector(
    (state) => state["selectionReducer"].userSettings
  )
  const [showPreferences, setShowPreferences] = useState(false)
  const [showLogoutDialog, setShowLogoutDialog] = useState(false)
  const [loading, setLoading] = useState(false)
  const [checkedUseSSIM, setCheckedUseSSIM] = useState(useSSIMView)

  useEffect(() => {
    setCheckedUseSSIM(useSSIMView)
  }, [useSSIMView])

  const exists =
    menu &&
    menu.find((item: IItem) => {
      return item.pageId === PageId.LogoutPage
    })
  const handlePref = () => {
    setShowPreferences(true)
  }
  const handleLogoutClick = async () => {
    try {
      await logout(pageId)
      dispatch(logoutUser({}))
      history.push("/")
    } catch (error) {
      console.error(error.message)
    }
  }

  const getChangeLinks = () => {
    let changeLinks = [
      {
        label: "Preferences",
        onClick: handlePref,
        title: "Preferences",
        icon: "settings"
      },
      {
        label: CommonText.logout,
        onClick: () => {
          setShowLogoutDialog(true)
        },
        title: CommonText.logout,
        icon: "logout"
      }
    ]

    if (versionInfo.handlingApplication === HandlingApp.FRAPORTGR) {
      changeLinks = changeLinks.filter((link) => link.title !== "Preferences")
    }

    return changeLinks
  }

  const renderPreferences = () => {
    return (
      <CustomModal
        isOpen
        onClose={(e: any) => {
          if (e.currentTarget === e.target) {
            setShowPreferences(false)
            setCheckedUseSSIM(useSSIMView)
          }
        }}
        title={"Preferences"}
        ctaText={CommonText.ok}
        onCallback={() => {
          dispatch(
            updateUserSettingsSelection({
              field: userSettingsKey.useSSIMView,
              value: checkedUseSSIM
            })
          )
          setShowPreferences(false)
        }}
        size="auto"
        onToggle={() => {
          setShowPreferences(!showPreferences)
          setCheckedUseSSIM(useSSIMView)
        }}
      >
        <section className="ocs-mt-20 ocs-mb-16 ocs-w-292">
          <RadioBooleanField
            caption="Flight Information"
            value={checkedUseSSIM}
            options={[
              { label: "Organised in Categories", value: false },
              { label: "Organised as SSIM", value: true }
            ]}
            onChange={(name, val) => {
              setCheckedUseSSIM(val)
            }}
            className="radio-field-lg"
          />
        </section>
      </CustomModal>
    )
  }

  const renderLogoutDialog = () => {
    return (
      <CustomModal
        isOpen
        onClose={(e: any) => {
          if (e.currentTarget === e.target) {
            setShowLogoutDialog(false)
          }
        }}
        title={"Confirm Log Out"}
        ctaText={"Log Out"}
        onCallback={() => {
          setShowLogoutDialog(false)
          handleLogoutClick()
        }}
        size="auto"
        onToggle={() => {
          setShowLogoutDialog(!showLogoutDialog)
        }}
      >
        <section className="ocs-mt-12 ocs-mb-16 ocs-w-292">
          Are you sure you want to log out of your account?
        </section>
      </CustomModal>
    )
  }

  // HTTP header authN - cf. also pages/home/Module.tsx
  const loginByHttpHeader = async () => {
    if (versionInfo.useHeaderAuth) {
      setLoading(true)
      const result = await login3(pageId, {})
      setLoading(false)

      if (result) {
        requestUserPermissions(pageId)
        dispatch(logonUser({ loginName: result.userName, authenticated: true }))
      }
      // } else {
      //   store.dispatch(
      //     notify({
      //       kind: NotificationKind.ERROR,
      //       title: "",
      //       message: "Single sign on failed - please contact us"
      //     })
      //   )
      // }
    }
  }

  return (
    <>
      {loading && (
        <LoadingPanel visible={true} loadingTxt="Loading Response..." />
      )}
      {userInfo.authenticated || exists ? (
        <DropdownButton
          links={getChangeLinks()}
          icon="person"
          className="navbar-dropdown"
        >
          {userInfo.loginName && userInfo.loginName.toUpperCase()}
        </DropdownButton>
      ) : (
        <NavLink
          to={{
            pathname: versionInfo.useHeaderAuth ? "/" : "/login",
            state: { from: { pathname: pathname } }
          }}
          className="ocs-ml-4"
        >
          <Button onClick={loginByHttpHeader} variant="primary">
            {CommonText.login}
          </Button>
        </NavLink>
      )}
      {showPreferences && renderPreferences()}
      {showLogoutDialog && renderLogoutDialog()}
    </>
  )
}
export default withRouter(LoginDialog)
